export default __webpack_public_path__ + "static/media/SWT0090.34I-21361_-14901_0.1f005b81.jpg";